import OWContainer from 'styles/styled-components/ow-container';
import { MaterialReactTable } from 'material-react-table';
import useController from '../controllers/nested-product-category-controller';

export const NestedProductCategoriesRoute = () => {
    const { tableSettings } = useController();

    return (
        <OWContainer>
            <MaterialReactTable table={tableSettings} />
        </OWContainer>
    );
};
